import i18n from '@fiverr/i18n/singleton';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { capitalizedFirstLetter } from '../../../utils/capitalizedFirstLetter';

export const translationKeyWithLocale = ({ k, locale, params }) => {
    const isEnLocale = locale === DEFAULT_FIVERR_LOCALE;
    const keyWithLocale = isEnLocale ? `${k}.en` : `${k}.other`;
    const paramsWithLocale = {
        ...params,
        $scope: locale,
    };

    const translatedKey = i18n.has(keyWithLocale, { $scope: locale })
        ? i18n.t(keyWithLocale, paramsWithLocale)
        : i18n.t(k, paramsWithLocale);

    return capitalizedFirstLetter(translatedKey);
};
